var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-client-only":"true"}},[(_vm.selectedSlot === 'default')?_vm._t("default"):_vm._e(),_vm._v(" "),(_vm.selectedSlot === 'placeholder')?_vm._t("placeholder"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }